import CaseStudyContext from '@App/pages/CaseStudy/CaseStudyContext/CaseStudyContext';

import { LOCATIONS } from './context.constants';

function Context() {
  return (
    <CaseStudyContext
      locations={LOCATIONS}
      sectionClassName="catalan-coast-context"
      mapCenter={[1.45, 41.05]}
      dotNavLabel="Catalan Coast location navigation"
      aboutIntro="Case study 1 covers the Catalan Coast with two distinct locations with their own characteristics:"
    />
  );
}

export default Context;
